import React, { useEffect, useState } from 'react';
import { Network } from '@capacitor/network';
import { WifiOff } from 'lucide-react';

/**
 * Persistent offline indicator so a dropped connection reads as a native
 * connectivity state, not a blank or broken screen. Works on native
 * (via the Network plugin) and on web (via the browser's online/offline
 * events).
 */
export const OfflineBanner = () => {
  const [online, setOnline] = useState(true);

  useEffect(() => {
    let listenerHandle;

    Network.getStatus().then((status) => setOnline(status.connected));

    Network.addListener('networkStatusChange', (status) => {
      setOnline(status.connected);
    }).then((handle) => {
      listenerHandle = handle;
    });

    return () => {
      listenerHandle?.remove();
    };
  }, []);

  if (online) return null;

  return (
    <div
      className="fixed inset-x-0 top-0 z-[100] flex items-center justify-center gap-2 bg-destructive text-destructive-foreground text-sm font-medium py-2 px-4"
      style={{ paddingTop: 'calc(0.5rem + env(safe-area-inset-top))' }}
      data-testid="offline-banner"
    >
      <WifiOff className="w-4 h-4" />
      You're offline &mdash; showing the last loaded data
    </div>
  );
};
